// extracted by mini-css-extract-plugin
export default {"base":"LastPage_base__E4qO+","text":"LastPage_text__il-c2","footer":"LastPage_footer__XTj9x","logo":"LastPage_logo__Pvg2R"};